import { Config } from '@/utils/Config';
import { Consoler } from '@/utils/Consoler';
import { angularAlexMapDirectiveTemplate } from './angular-alex-map.directive.template';
import { EventBus } from '@/utils/EventBus';
import { Position } from '@/models/position';
import { Point } from '@/models/point';
import {
    regionKontorPreset,
    voPreset,
    sboPreset,
} from '@/assets/memberContactsPresets';
import { RegionOfficeResult } from '@/models/regionOfficeResult';

export function angularAlexMapDirective(localizations, alConfig) {
    const directive = {
        restrict: 'E',
        template: angularAlexMapDirectiveTemplate.template,
        scope: {},

        link: (scope) => {
            scope.localizations = localizations;

            scope.points = [];
            scope.latestCoordinates = [
                Config.DefaultMapCoordsLng,
                Config.DefaultMapCoordsLat,
            ];
            scope.latestProjection = Config.MapProjection;

            scope.map = {
                isFullScreen: false,

                pos: {
                    coordinates: scope.latestCoordinates,
                    projection: scope.latestProjection,
                    zoom: 8,
                },

                basePresets: [
                    {
                        presetName: 'extweb/karta',
                        displayName: localizations.mapLayers.extweb_karta,
                    },
                ],

                addonPresets: [
                    {
                        presetName: regionKontorPreset,
                        displayName: 'Kontorsplatser',
                        visible: true,
                    },
                    // {
                    //     presetName: voPreset,
                    //     displayName: localizations.mapLayers.extweb_vo,
                    //     visible: false,
                    // },
                    {
                        presetName: sboPreset,
                        displayName: localizations.mapLayers.extweb_sbo,
                        visible: true,
                    },
                ],

                activePresets: ['extweb/karta'],

                vectorLayers: [],

                pointStyle: {
                    icon: {
                        anchor: [0.5, 1],
                        opacity: 1,
                        scale: 0.5,
                        src: alConfig.getIconUrl() + '/karta_pin.png',
                    },
                },
            };

            scope.$root.$on('al-map:created', (event, alMap) => {
                scope.alMap = alMap;
                Consoler.debugLog('Alex map created', alMap);
            });

            scope.$root.$on('al-map:info-click', (event, response) => {
                Consoler.debugWarn('Position selected', response.position);
                let selectedPosition: Position | null = null;

                if (response.position !== null) {
                    selectedPosition = {
                        longitude: response.position[0],
                        latitude: response.position[1],
                    };
                }

                if (response.feature !== null && response.feature.properties.KONTOR_TYP === 'Regionkontor') {
                    Consoler.debugLog('Regionoffice selected: ', response.feature);
                    const regionOfficeResult: RegionOfficeResult = {
                        objectId: response.feature.properties.OBJECTID,
                        position: selectedPosition
                    }
                    EventBus.$emit(Config.MapRegionOfficeSelectedEvent, regionOfficeResult);
                    return;
                }

                EventBus.$emit(Config.MapPositionSelectedEvent, selectedPosition);
            });

            EventBus.$on(Config.MapClearPointsEvent, () => {
                scope.points = [];
            });

            EventBus.$on(Config.MapSetPointEvent, (selectedPoint: Point) => {
                Consoler.debugLog('Setting point on map', selectedPoint);
                scope.points.push(selectedPoint);
                scope.latestCoordinates = selectedPoint.coordinates;
                scope.latestProjection = selectedPoint.projection;
                scope.alMap.panTo(selectedPoint.coordinates, selectedPoint.projection);
            });

            EventBus.$on(Config.MapShowVoOrSboLayerEvent, (showVoNotSboLayer) => {
                Consoler.debugLog('Showing map layer, vo?', showVoNotSboLayer);

                // remove existing layers
                scope.map.addonPresets.splice(1);

                // add layers
                if (showVoNotSboLayer) {
                    scope.map.addonPresets.push({
                        presetName: sboPreset,
                        displayName: localizations.mapLayers.extweb_sbo,
                        visible: false,
                    });
                } else {
                    scope.map.addonPresets.push({
                        presetName: sboPreset,
                        displayName: localizations.mapLayers.extweb_sbo,
                        visible: true,
                    });
                }

                setTimeout(() => {
                    // Pan to coordinates (slightly adjusted), a "hack" to force render update
                    scope.latestCoordinates[1] = scope.latestCoordinates[1] + 0.00000001;
                    scope.alMap.panTo(
                        [scope.latestCoordinates[0], scope.latestCoordinates[1]],
                        scope.latestProjection
                    );
                });
            });

            scope.$watch('map.pos.zoom', (zoom) => {
                setTimeout(() => {
                    if (zoom >= Config.MapMaxZoom) {
                        Consoler.debugLog(
                            'Tried to zoom map above max',
                            zoom + 1,
                            'setting to max',
                            Config.MapMaxZoom
                        );
                        scope.alMap.setZoom(Config.MapMaxZoom);
                    }
                });
            });

            scope.fullscreen = (isFullScreen: boolean) => {
                scope.map.isFullScreen = isFullScreen;
                EventBus.$emit(Config.MapSetFullScreenEvent, isFullScreen);
                setTimeout(() => {
                    scope.alMap.updateSize();
                });
            };

            scope.toggleMapLegend = (hide: boolean) => {
                EventBus.$emit(Config.MapToggleLegendEvent);
            };
        },
    };
    return directive;
}
